import { ChangeEvent, useState } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import { SingleLineTextViewModel } from '../../types/singleLineText';
import JabraInput from '../Shared/JabraInput';
import JabraLegend from '../Shared/JabraLegend';

const Telephone: React.FC<ValueFieldProps<SingleLineTextViewModel>> = (props) => {
  const { field, isValid } = props;
  const { id, name } = field.valueField;
  const { labelCssClass, placeholderText, required, showLegend, title } = field.model;
  const [value, setValue] = useState(props.value);
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const Label = props.labelComponent;

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event?.target?.value;
    setValue(newValue);
    props.onChange(name, newValue, isValid, []);
  };

  return (
    <>
      {!!Label && <Label {...props} />}
      <JabraInput
        type="tel"
        id={id}
        name={name}
        value={value}
        jssMetadata={props}
        placeholder={placeholderText}
        required={required}
        onChange={onChange}
      />
      {showLegend && !!title && (
        <JabraLegend className={labelCssClass} dangerouslySetInnerHTML={{ __html: title }} />
      )}
      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};
export default Telephone;
